var _rect, _rect2, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmail = function SvgEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 70 70"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 45.688,
    height: 32.874,
    x: 2,
    y: 29,
    fill: "#2F68D1",
    opacity: 0.5,
    rx: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2F68D1",
    fillRule: "evenodd",
    d: "M26.046 47.273a2 2 0 0 1-2.404 0L2.309 31.229A2 2 0 0 1 2 30.947L2 31v28.874a2 2 0 0 0 2 2h41.688a2 2 0 0 0 2-2V30.947q-.135.15-.309.282z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F68D1",
    fillRule: "evenodd",
    d: "M14 19a2 2 0 0 0-2 2v8h33.688a2 2 0 0 1 2 2v20.874h8a2 2 0 0 0 2-2V21a2 2 0 0 0-2-2z",
    clipRule: "evenodd",
    opacity: 0.75
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F68D1",
    fillRule: "evenodd",
    d: "M24 9a2 2 0 0 0-2 2v8h33.688a2 2 0 0 1 2 2v20.874h8a2 2 0 0 0 2-2V11a2 2 0 0 0-2-2z",
    clipRule: "evenodd",
    opacity: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF9D43",
    d: "M12.966 13.933c-.268-2.586-.527-3.882-1.306-4.66-.778-.78-2.074-1.039-4.66-1.307 2.586-.268 3.882-.527 4.66-1.306.779-.778 1.038-2.074 1.306-4.66.268 2.586.528 3.881 1.307 4.66s2.074 1.038 4.66 1.306c-2.586.268-3.882.528-4.66 1.307-.78.778-1.039 2.074-1.307 4.66M5.5 19.933c-.112-1.084-.221-1.627-.547-1.953s-.87-.435-1.953-.547c1.084-.113 1.626-.221 1.953-.547.326-.327.435-.87.547-1.953.112 1.083.221 1.626.547 1.953.327.326.87.434 1.953.547-1.084.112-1.626.22-1.953.547-.326.326-.435.87-.547 1.953"
  })));
};
export default SvgEmail;